import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useFormikContext } from 'formik';
import DefaultPathLengths from '../../../data/constants/DefaultPathLengths';
import Label from '../../elements/Label';
import FormikNumberInput from '../../elements/formik/FormikNumberInput';
const editPathLengthsStyles = css `
  width: 100%;
  height: 100%;
  margin-top: 10px;
  text-align: center;

  .input-container {
    width: 100%;
    margin-top: 5px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      appearance: none;
    }
  }

  button {
    flex: 2;
    padding: 5px;
    border: 1px solid gray;
    border-radius: 5px;
    height: 30px;
    margin: 0 auto;
    margin-top: 15px;
    display: block;
    width: 60px;
    color: white;
    background-color: gray;
  }

  .warning {
    margin-top: 5px;
    color: red;
  }
`;
function EditPathLengthFormik({ signalIndex }) {
    const { errors, values, } = useFormikContext();
    return (_jsxs("div", { css: editPathLengthsStyles, children: [_jsx("p", { children: "Setting of the minimum and maximum path length (J coupling)." }), _jsxs("div", { className: "input-container", children: [_jsx(Label, { title: "Min:", children: _jsx(FormikNumberInput, { name: `signals[${signalIndex}].j.pathLength.from`, defaultValue: values.signals[signalIndex].j?.pathLength?.from ||
                                DefaultPathLengths[values.experimentType]?.from ||
                                1, style: {
                                color: errors.signals?.[signalIndex].j?.pathLength?.from
                                    ? 'red'
                                    : 'black',
                            }, min: 1, max: values.signals[signalIndex].j?.pathLength?.to ||
                                DefaultPathLengths[values.experimentType]?.to, pattern: "[1-9]+" }) }), _jsx(Label, { title: "Max:", children: _jsx(FormikNumberInput, { name: `signals[${signalIndex}].j.pathLength.to`, defaultValue: values.signals[signalIndex].j?.pathLength?.to ||
                                DefaultPathLengths[values.experimentType]?.to ||
                                1, style: {
                                color: errors.signals?.[signalIndex].j?.pathLength?.to
                                    ? 'red'
                                    : 'black',
                            }, min: values.signals[signalIndex].j?.pathLength?.from ||
                                DefaultPathLengths[values.experimentType]?.from ||
                                1, pattern: "[1-9]+" }) })] })] }));
}
export default EditPathLengthFormik;
